// extracted by mini-css-extract-plugin
module.exports = {"ForgotPasswordForm":"ForgotPasswordForm--3i2Xg","Extra":"Extra--Yfaat","Flat":"Flat--1ctKe"};